






import Vue from 'vue';

export default Vue.extend({
	name   : 'PassageFilters',
	data() {
		return {};
	},
	methods: {
		handleChange(numberOfParagraphs: number) {
			this.$router.push({
				params: {
					numberOfParagraphs: String(numberOfParagraphs),
				},
			});
		},
	},
});
